<style lang="less">
  #home{
    height: 100%;
    // min-height: 100%;
    .ouertContaint{
      min-height: 100%;
      // padding-bottom: 100px;
      padding-bottom: 170px;
    }
  }
</style>
<template>
<div>
  <div id="home">
    <div class="ouertContaint">
      <top :show="showSearch" ref="heard"></top>
      <right-icon></right-icon>
      <router-view></router-view>
    </div>
    <bottom style="margin-top:-170px"></bottom>
  </div>
</div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import Top from '../../components/top/top.vue'
  import Bottom from '../../components/bottom/Bottom.vue'
  import RightIcon from '../../components/rightIcon/RightIcon.vue'
  export default {
    data() {
      return {
        a:1,
        showSearch:true
      }
    },
    computed:{
      ...mapGetters({
          ds:'home/getData'
        })
    },
    mounted(){
      this.$store.dispatch('home/getDataAction',{bbb:111})
      // if(window.location.search.indexOf('show') !== -1 || window.location.pathname.indexOf('/usercenter')!==-1){
      //   this.showSearch = false;
      // }else{
      //   this.showSearch = true;
      // }
    },
    components:{
      RightIcon,
      Top,
      Bottom
    },
    methods:{
      handleClick(code){
        // console.log(code)
      }
    },
    // beforeRouteUpdate(to,from,next){
    //   console.log(to)
    //   if(to.query.show === '1' || to.path === "/usercenter"){
    //     this.showSearch = false;
    //   }else{
    //     this.showSearch = true;
    //   }
    //   next()
    // }

  }
</script>




// WEBPACK FOOTER //
// src/views/home/Home.vue